import * as React from 'react';

import { Graph } from '../data/misc';

export const GraphDataContext = React.createContext<Graph | undefined>(
  undefined
);
